import React from "react";

const GetRequiredAsterisk = ({ required }) => {
  return <React.Fragment>{required ? " *" : null}</React.Fragment>;
};

export default GetRequiredAsterisk;
